import { track, logError } from '@tracking';
import getLocationPointAreaName from '@commons/models/LocationPoint/getters/getAreaName';
import isLocationPointFromSearchArea from '@commons/models/LocationPoint/validations/isFromSearchArea';
import {
  isLocationPointFromGPS,
  getLocationPointCityName,
  isLocationPointFromSearch,
} from '@commons/models/LocationPoint';
import { getLocationMethod } from '@utils/trackingUtils';
import { NOT_SET } from '@utils/tracking/constants';
import { getCountryName } from '@shared/selectors';
import { isGPSEnabled } from '@utils/navigatorGeolocation';
import { getSearchId } from '@tracking/services/location.service';
import locationToString from '@commons/models/LocationPoint/mappers/toStringWithCityAndCountry';
import { COUNTRY_NAME } from '@commons/constants';
import getSessionId from '@core/reducers/user/selectors/getSessionId';

const EVENT_NAME = 'address_submitted.started';

const getFormType = (countryName, fromSearch) => {
  if (fromSearch) {
    switch (countryName) {
      case COUNTRY_NAME.PANAMA:
        return 'area_list';
      default:
        return 'city';
    }
  }
  return NOT_SET;
};

const trackAddressSubmittedStarted = ({ points } = {}) => (_, getState) => {
  try {
    const state = getState();
    const searchId = getSearchId(true);
    const dbSearchGuid = getSessionId(state);
    const country = getCountryName(state);

    let fromGPS = true;
    let fromSearch = false;
    let locationProps = {
      locationLat: NOT_SET,
      locationLon: NOT_SET,
      locationAreaName: NOT_SET,
      locationCity: NOT_SET,
      locationAddress: NOT_SET,
    };

    if (points?.length) {
      const point = points[0];
      const { latitude, longitude } = point;
      fromGPS = isLocationPointFromGPS(point);
      fromSearch =
        isLocationPointFromSearch(point) ||
        isLocationPointFromSearchArea(point);
      locationProps = {
        locationLat: latitude,
        locationLon: longitude,
        locationAreaName: getLocationPointAreaName(point),
        locationCity: getLocationPointCityName(point),
        locationAddress: locationToString(point, country),
      };
    }

    const payload = {
      ...locationProps,
      locationMethod: getLocationMethod({ fromGPS }),
      cookie: NOT_SET,
      gps: isGPSEnabled(),
      formType: getFormType(country, fromSearch),
      geoCodingResults: NOT_SET,
      ourResults: NOT_SET,
      zip: NOT_SET,
      zipFound: false,
      searchId,
      searchByType: NOT_SET,
      dbSearchGuid,
    };
    track(EVENT_NAME, payload, {
      excludeFromCommon: ['locationLat', 'locationLon'],
    });
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackAddressSubmittedStarted;
